import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-day-switcher-buttons-round',
  templateUrl: './day-switcher-buttons-round.component.html',
  styleUrls: ['./day-switcher-buttons-round.component.scss'],
  standalone: false,
})
export class DaySwitcherButtonsRoundComponent {
  @Input() dayStart: boolean = true;
  @Input() isLoading: boolean = false;

  @Output() startDay = new EventEmitter<void>();
  @Output() endDay = new EventEmitter<void>();

  onStartDay() {
    if (this.isLoading) return;
    this.startDay.emit();
  }

  onEndDay() {
    if (this.isLoading) return;
    this.endDay.emit();
  }

  get actionLabelKey(): string {
    return this.dayStart
      ? 'PROVIDER.DAMANDE.SESSION_BUTTON_START'
      : 'PROVIDER.DAMANDE.SESSION_BUTTON_STOP';
  }
}


